import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#133E87' },
    secondary: { main: '#608BC1' },
    success: { main: '#15803D', light: '#D1FAE5' },
    warning: { main: '#B45309', light: '#FEF3C7' },
    error: { main: '#DC2626', light: '#FEE2E2' },
    background: { default: 'whitesmoke', paper: '#CBDCEB' },
    text: {
      primary: '#133E87',
      secondary: '#6B7280',
    },
    divider: '#e0eaf5',
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', Arial, sans-serif",
    h1: { fontWeight: 900, fontSize: 'clamp(2.2rem, 5vw, 3.75rem)' },
    h2: {
      fontWeight: 900,
      fontSize: 'clamp(1.9rem, 4vw, 3rem)',
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      '@media (max-width: 850px)': {
        paddingTop: '4rem',
        paddingBottom: '0.05rem',
      },
    },
    h3: { fontWeight: 700, fontSize: 'clamp(1.6rem, 3.5vw, 2.5rem)' },
    h4: { fontWeight: 700, fontSize: 'clamp(1.3rem, 2.5vw, 1.85rem)' },
    h5: { fontWeight: 700, fontSize: 'clamp(1.15rem, 2vw, 1.5rem)' },
    h6: { fontWeight: 700, fontSize: 'clamp(1.05rem, 1.5vw, 1.25rem)' },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  shape: {
    borderRadius: 24,
  },
  components: {
    // Seed values for the navbar geometry Navbar publishes at runtime, so sticky page
    // chrome is positioned correctly in the react-snap snapshot before JS measures the
    // real bar. 68px is the desktop toolbar height.
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          '--navbar-h': '68px',
          '--navbar-h-max': '68px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: '12px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: '24px' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: '8px' },
      },
    },
  },
});

export default theme;
